Vue.asyncComponent('ak-icon-button', {
    props: {
        icon: {
            type: String,
            required: false,
        },
        href: {
            type: String,
            required: false,
            default: ''
        },
        target: {
            type: String,
            required: false,
            default: '_self'
        },
        description: {
            type: String,
            required: false,
        },
        descriptionPosition: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        colorMode: {
            type: String,
            required: false,
            default: ''
        },
        size: {
            type: String,
            required: false,
        },
        active: {
            type: Boolean,
            default: false,
            required: false,
        },
        shadow: {
            type: Boolean,
            default: false,
            required: false,
        },
        enableConfirm: {
            type: Boolean,
            required: false,
            default: false
        },
        confirmTitle: {
            type: String,
            required: false,
        },
        confirmText: {
            type: String,
            required: false,
        },
        tabindex: {
            type: String|Number,
            required: false
        }
    },
    data() {
        return {
            clickActive: false,
            clickOut: false,
            showConfirm: false,
        }
    },
    methods: {
        click(e) {
            if (this.disabled) {
                return;
            }

            if (this.enableConfirm) {
                this.showConfirm = true;
                return;
            }

            // If a href is set, only use that.
            if (this.href) {
                this.$actionHandler.handleRoute({route:this.href, target:this.target});
            }
            this.$emit('click', e);
        },
        setClickActive: function () {
            this.clickActive = true;
            setTimeout(() => {
                this.clickActive = false;
                this.setClickOut();
            }, 300)
        },
        setClickOut() {
            this.clickOut = true;

            setTimeout(() => {
                this.clickOut = false;
            }, 300)
        },
        onConfirm(e) {
            this.showConfirm = false;

            // If a href is set, only use that.
            if (this.href) {
                this.$actionHandler.handleRoute({route:this.href, target:this.target});
            }
            this.$emit('click', e);
        },
        onCancel(e) {
            this.showConfirm = false;
        }
    }
}, 'layout/ak-icon-button.html');